import type { StateCreator } from 'zustand';

import type { StoreType } from '.';

export type SurveySlice = {
   canUserAnswerSurvey: boolean;
   setCanUserAnswerSurvey: (value: boolean) => void;
};

export const surveySlice: StateCreator<StoreType, [], [], SurveySlice> = (
   set,
) => ({
   canUserAnswerSurvey: true,
   setCanUserAnswerSurvey: (value: boolean) =>
      set({ canUserAnswerSurvey: value }),
});
